import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/shared/services/data/data.service';

@Component({
  selector: 'app-sign-in-user',
  templateUrl: './sign-in-user.component.html',
  styleUrls: ['./sign-in-user.component.scss']
})
export class SignInUserComponent implements OnInit {

  constructor(
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.initComponent();
  }

  private initComponent(): void {
    this.dataService.tabHome$.next('other');
    this.dataService.titleHomePage.next('Connexion utilisateur');
  }

}
